@if (visible()) {
  <section
    class="flex flex-col gap-4 pb-6"
    data-testid="personal-job-search-frame">
    <h1 class="m-0 text-page-headline-sm">
      {{ 'personalJobSearch.title' | translate }}
    </h1>
    <div
      role="note"
      class="flex items-start gap-3 rounded-xl bg-light-primary-container p-4 text-light-on-primary-container">
      <mat-icon class="material-symbols-rounded shrink-0" aria-hidden="true"
        >info</mat-icon
      >
      <span>
        <strong>{{ 'personalJobSearch.note.title' | translate }}</strong>
        {{
          organisationName()
            ? ('personalJobSearch.note.text'
              | translate: { organisation: organisationName() })
            : ('personalJobSearch.note.textNoOrganisation' | translate)
        }}
      </span>
    </div>
    <nav
      class="flex gap-1 overflow-x-auto border-b border-light-outline-variant"
      [attr.aria-label]="'personalJobSearch.tabsLabel' | translate">
      @for (tab of tabs; track tab.key) {
        <a
          class="inline-flex min-h-12 shrink-0 items-center gap-2 whitespace-nowrap border-b-2 px-4 no-underline"
          [class.border-light-primary]="activeTab()?.key === tab.key"
          [class.font-bold]="activeTab()?.key === tab.key"
          [class.text-light-on-surface]="activeTab()?.key === tab.key"
          [class.border-transparent]="activeTab()?.key !== tab.key"
          [class.font-medium]="activeTab()?.key !== tab.key"
          [class.text-light-on-surface-variant]="activeTab()?.key !== tab.key"
          [attr.aria-current]="activeTab()?.key === tab.key ? 'page' : null"
          [attr.data-testid]="'personal-tab-' + tab.key"
          [routerLink]="tab.link"
          [target]="tab.newWindow ? '_blank' : undefined"
          [attr.rel]="tab.newWindow ? 'noopener' : null">
          {{ 'personalJobSearch.tabs.' + tab.key | translate }}
          @if (tab.newWindow) {
            <mat-icon class="material-symbols-rounded" aria-hidden="true"
              >open_in_new</mat-icon
            >
            <span class="sr-only">{{
              'personalJobSearch.newWindow' | translate
            }}</span>
          }
        </a>
      }
    </nav>
  </section>
}
